import { select } from '@panel/commons/core/themev2';
import styled from 'styled-components';

const PriceSelectorContainer = styled.div``;

const Divider = styled.div`
  height: 1px;
  background-color: ${select('neutralDarkGray')};
  margin: 24px 0;
`;

const ExpensesContainer = styled.div`
  width: 100%;
  height: 48px;
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 16px;
  > p {
    font-family: Hind;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
  }
`;

const CreditAcceptanceContainer = styled.div`
  width: 100%;
  height: 48px;
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 16px;
  > p {
    font-family: Hind;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
  }
`;

export { PriceSelectorContainer, Divider, ExpensesContainer, CreditAcceptanceContainer };
